export default "__VITE_ASSET__D3_U0LS0__"